import { useEffect, useRef, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Remove, Add, RestartAlt } from "@mui/icons-material";
import { ToolTip } from "./ToolTip";

const ZOOM_STEP = 0.05; // Controls how fast zoom happens - 5% per click/zoom action
const MIN_ZOOM = 0.1; // Set the lowest possible zoom - Can't go smaller than 10%
const MAX_ZOOM = 2; // Sets the highest possible zoom - Can't go bigger than 200%

export const Zoom = ({ children }) => {
    const [zoom, setZoom] = useState(1);
    const wrapperRef = useRef();

    const zoomIn = () => setZoom((z) => Math.min(z + ZOOM_STEP, MAX_ZOOM));
    const zoomOut = () => setZoom((z) => Math.max(z - ZOOM_STEP, MIN_ZOOM));
    const resetZoom = () => setZoom(1);

    // Scroll zoom handling (with Ctrl key)
    useEffect(() => {
        const handleWheel = (e) => {
            if (e.ctrlKey) {
                e.preventDefault();
                setZoom((z) => {
                    if (e.deltaY < 0) return Math.min(z + ZOOM_STEP, MAX_ZOOM);
                    else return Math.max(z - ZOOM_STEP, MIN_ZOOM);
                });
            }
        };
        const wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("wheel", handleWheel, { passive: false });
        }
        return () => {
            if (wrapper) {
                wrapper.removeEventListener("wheel", handleWheel);
            }
        };
    }, []);

    return (
        <Box ref={wrapperRef} sx={{ display: 'flex', justifyContent: 'center' }}>
            {/* Zoom Controls */}
            <Box mb={2} display="flex" gap="8px" alignItems="center" sx={{ position: 'fixed', bottom: '16px', right: '32px',zIndex: 1000, flexDirection: 'column' }}>
                <ToolTip title="Zoom Out">
                    <IconButton onClick={zoomOut} sx={{ p: '2px', border: '1px solid #003F2E', ':hover': { bgcolor: '#edf3eeff' }}}>
                        <Remove sx={{ color: '#003022', fontSize: 12 }} />
                    </IconButton>
                </ToolTip>
                <Typography fontSize={12} fontWeight={600} textAlign="center">{Math.round(zoom * 100)}%</Typography>
                <ToolTip title="Zoom In">
                    <IconButton onClick={zoomIn} sx={{ p: '2px', border: '1px solid #003F2E', ':hover': { bgcolor: '#edf3eeff' } }}>
                        <Add sx={{ color: '#003022', fontSize: 12 }} />
                    </IconButton>
                </ToolTip>
                <ToolTip title="Zoom Reset">
                    <IconButton onClick={resetZoom} sx={{ p: '2px', border: '1px solid #003F2E', ':hover': { bgcolor: '#edf3eeff' } }}>
                        <RestartAlt sx={{ color: '#003022', fontSize: 12 }} />
                    </IconButton>
                </ToolTip>
            </Box>
            {/* Zoomed Content */}
            <Box
                sx={{
                    transform: `scale(${zoom})`,
                    transformOrigin: 'center top',
                    transition: 'transform 0.2s ease-in-out',
                    width: "fit-content",
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
